import http from "../../../services/httpService";
import { injectHtml } from "../../../utils/htmlUtil";
import { error, isEmpty } from "../../common/global";
import { catchError } from "../../../utils/errorUtil";
import { bindSearchAutocomplete, noResultHtml } from "../../common/autocomplete";
import { openSnackbar, snackbarModel } from "../../common/snackbar";
import forms from "../../common/forms"

const props = {
    adminProductCategoryPickerMarker: '#marker-product-category-picker',
    productId: '.category-picker-editor-parent-id',
    productCategoryPickerWrapper: '#product-category-picker-editor-wrapper',
    productCategoryPickerWrapperId: 'product-category-picker-editor-wrapper'
};

export function initAdminProductCategoryPicker() {

    if ($(props.adminProductCategoryPickerMarker).length) {

        bindCategoryPickerEvents();
    }
}
function bindCategoryPickerEvents() {

    //bind autocomplete events
    initCategorySearchAutoComplete();

    //bind deletion event
    initCategoryPickerDeleteEvents();    
}

async function initCategorySearchAutoComplete() {

    catchError(async function () {

        const containerId = '#search-categories';
        const autoComplete = `${containerId} .search-autocomplete`;

        bindSearchAutocomplete(containerId, async function (outputSearchTerm) {

            const data = {
                searchTerm: outputSearchTerm
            };

            const result = await getSearchProductCategoriesAutocompleteHtml(data);

            const isDataEmpty = isEmpty(result);

            if (isDataEmpty) return injectHtml(autoComplete, noResultHtml);

            await injectHtml(autoComplete, result);

            $(autoComplete).find('.autocomplete-item').off('click').on('click', async function (e) {

                //post back, saving the selected benefit against the product. reload the relevant table when complete.
                const selectedCategoryId = $(this).data('id');

                const productCategoryData = {
                    productId: $(props.productId).val(),
                    categoryId: selectedCategoryId
                };

                var result = await addProductCategoryService(productCategoryData);

                reloadCategoryPickerEditor();

                if (result.responseResult === "NONE") {

                    //display confirmation message to the user
                    openSnackbar({
                        ...snackbarModel,
                        content: result.responseMessage
                    });
                }
                else {

                    //display error / warning message to the user
                    openSnackbar({
                        ...snackbarModel,
                        content: result.responseMessage,
                        theme: 'error'
                    });
                }

            });
        });
    });
}

async function reloadCategoryPickerEditor() {

    //load category picker 
    const data = {
        productId: $(props.productId).val()
    };

    const result = await getCategoryPickerHtml(data);

    const isDataEmpty = isEmpty(result);

    if (isDataEmpty) return injectHtml($(props.productCategoryPickerWrapper), noResultHtml);

    await injectHtml($(props.productCategoryPickerWrapper), result);


    window.mdc.autoInit(document.getElementById(props.productCategoryPickerWrapperId));

    bindCategoryPickerEvents();
}

async function initCategoryPickerDeleteEvents() {

    $('.delete-category-picker-item').off('click').on('click', async function (e) {

        //called when the 'remove' button is clicked 
        const data = {
            productCategoryItemId: $(this).data('id')
        };

        var result = await deleteProductCategoryService(data);

        reloadCategoryPickerEditor();


        if (result.responseResult === "NONE") {
            //display confirmation message to the user
            openSnackbar({
                ...snackbarModel,
                content: result.responseMessage
            });
        }
        else {
            openSnackbar({
                ...snackbarModel,
                content: result.responseMessage,
                theme: 'error'
            });
        }

        
    });
}

//API CALLS

async function getCategoryPickerHtml(data) {

    //no TRY CATCH as handled by parent
    const response = await http.get('/administration/categorymanagement/getcategorypickereditor', data);
    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}

async function getSearchProductCategoriesAutocompleteHtml(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/categorymanagement/searchcategorylistitems', data);
    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}

async function addProductCategoryService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/categorymanagement/addproductcategoryitem', data);
    // The response is an object with a property called 'data'. 
    return response.data;
}

async function deleteProductCategoryService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/categorymanagement/deleteproductcategoryitem', data);
    // The response is an object with a property called 'data'. 
    return response.data;
}